module.exports = __webpack_public_path__ + "static/media/actividades.e6514c3b.jpg";